module.exports = __webpack_public_path__ + "static/media/online.735f2b08.svg";